var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"main-card",class:`${_vm.lightMode ? 'accent' : 'primary'}`,style:(`${_vm.addPadding ?'padding: 1%' :''}`),attrs:{"elevation":"12"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }